import { render, staticRenderFns } from "./GroupType.vue?vue&type=template&id=cf857a98&scoped=true"
import script from "./GroupType.vue?vue&type=script&lang=js"
export * from "./GroupType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf857a98",
  null
  
)

export default component.exports